function u(n, r) {
  return function() {
    return n.apply(r, arguments);
  };
}
export {
  u as default
};
